<ng-container
  *ngIf="{
    filteredSearchList: filteredSearchList$ | async,
    fuzzySearchList: fuzzySearchList$ | async
  } as dataOwner"
>
  <form [formGroup]="formGroup">
    <mat-form-field
      [appearance]="formFieldAppearance"
      [floatLabel]="floatLabel"
      [hideRequiredMarker]="!isRequired"
    >
      <mat-label>{{ label }}</mat-label>

      <input
        type="text"
        [placeholder]="placeholder"
        aria-label=""
        matInput
        formControlName="searchTerm"
        [matAutocomplete]="auto"
        [required]="isRequired"
        (blur)="onBlurEvent($event)"
      />

      <mat-icon
        matSuffix
        *ngIf="!formGroup.controls.searchTerm.value && !svgSearchIconName"
        >search</mat-icon
      >
      <mat-icon
        matSuffix
        *ngIf="!formGroup.controls.searchTerm.value && svgSearchIconName"
        [svgIcon]="svgSearchIconName"
      ></mat-icon>

      <button
        type="button"
        *ngIf="formGroup.controls.searchTerm.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="clear()"
      >
        <mat-icon *ngIf="!svgCloseIconName">close</mat-icon>
        <mat-icon
          *ngIf="svgCloseIconName"
          [svgIcon]="svgCloseIconName"
        ></mat-icon>
      </button>

      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayNameFn"
        (optionSelected)="onOptionSelected($event)"
      >
        <ng-container *ngIf="shouldHaveFuzzyResults; else noFuzzyResults">
          <!-- EXACT MATCHES -->
          <mat-optgroup label="Exact Matches" *ngIf="dataOwner.filteredSearchList?.length > 0">
            <ng-container *ngFor="let option of dataOwner.filteredSearchList">
              <ng-container
                *ngIf="
                  option.data?.optionGroupCount &&
                    option.data?.optionGroupCount > 1;
                  else singleOption
                "
              >
                <mat-optgroup
                  class="grouping sticky"
                  [label]="displayCountFn(option)"
                >
                  <mat-option
                    *ngFor="
                      let subOption of option.data.optionGroups;
                      let i = index
                    "
                    [value]="subOption"
                  >
                    {{ displayLabel(subOption, i) }}
                  </mat-option>
                </mat-optgroup>
              </ng-container>
              <ng-template #singleOption>
                <mat-option [value]="option">
                  {{ displayLabel(option) }}
                </mat-option>
              </ng-template>
            </ng-container>
          </mat-optgroup>

          <!-- SIMILAR (FUZZY) MATCHES: only when no exact results -->
          <mat-optgroup label="Similar Matches" *ngIf="dataOwner.fuzzySearchList?.length > 0 && !dataOwner.filteredSearchList?.length">
            <mat-option
              class="text-amber-600"
              *ngFor="let option of dataOwner.fuzzySearchList"
              [value]="option"
            >
              {{ displayLabel(option) }}
              <span class="text-xs text-amber-600 ml-2">(close match)</span>
            </mat-option>
          </mat-optgroup>
        </ng-container>

        <ng-template #noFuzzyResults>
          <ng-container *ngFor="let option of dataOwner.filteredSearchList">
            <!-- DISPLAY AUTO-COMPLETE OPTION WITH OPTION GROUPS -->
            <ng-container
              *ngIf="
                option.data?.optionGroupCount &&
                  option.data?.optionGroupCount > 1;
                else singleOptionNoFuzzy
              "
            >
              <mat-optgroup
                class="grouping sticky"
                [label]="displayCountFn(option)"
              >
                <mat-option
                  *ngFor="
                    let subOption of option.data.optionGroups;
                    let i = index
                  "
                  [value]="subOption"
                >
                  {{ displayLabel(subOption, i) }}
                </mat-option>
              </mat-optgroup>
            </ng-container>

            <!-- DISPLAY AUTO-COMPLETE OPTION HAVING NO OPTION GROUPS -->
            <ng-template #singleOptionNoFuzzy>
              <mat-option [value]="option">
                {{ displayLabel(option) }}
              </mat-option>
            </ng-template>
          </ng-container>
        </ng-template>
      </mat-autocomplete>

      <mat-error
        *ngIf="
          formGroup.controls.searchTerm.hasError('required') ||
          formGroup.controls.searchTerm.hasError('invalid')
        "
      >
        {{ errorMessage }}
      </mat-error>
    </mat-form-field>
    <div *ngIf="(isFilteredSearchListEmpty$ | async) && !(shouldHaveFuzzyResults && (hasFuzzyResults$ | async))">
      <ng-content select="[errorTemplate]"></ng-content>
    </div>
  </form>
</ng-container>
